import { useState } from 'react';
import differentiators from '../content/differentiators';

export default function Differentiators() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  // Open card on hover
  const handleMouseEnter = (idx) => setExpandedIndex(idx);
  const handleMouseLeave = () => setExpandedIndex(null);

  return (
    <section id="differentiators" className="py-16 px-6 text-white">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
          What Sets Us Apart
        </h2>

        <div className="flex flex-col gap-4">
          {differentiators.map((item, idx) => {
            const isOpen = expandedIndex === idx;
            const panelId = `differentiator-panel-${idx}`;

            return (
              <div
                key={idx}
                className="bg-gray-900 border border-gray-700 rounded-xl p-5 shadow-md"
                onMouseEnter={() => handleMouseEnter(idx)}
                onMouseLeave={handleMouseLeave}
              >
                {/* Header row: title on left, + button on right */}
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-3">
                    {/* optional icon */}
                    {item.iconClass && (
                      <i
                        className={`${item.iconClass} text-2xl text-blue-400`}
                      />
                    )}
                    <h3 className="text-xl font-semibold text-white text-center">
                      {item.title}
                    </h3>
                  </div>
                  {/* Decorative plus/minus icon for visual feedback */}
                  <span
                    className="inline-flex items-center justify-center w-9 h-9 rounded-md text-blue-300 bg-transparent"
                    aria-label={isOpen ? 'Collapse' : 'Expand'}
                  >
                    <i
                      className={`fas ${isOpen ? 'fa-minus' : 'fa-plus'} text-xl`}
                    />
                  </span>
                </div>

                {/* Collapsible body */}
                <div
                  id={panelId}
                  role="region"
                  aria-hidden={!isOpen}
                  className={`grid transition-[grid-template-rows] duration-300 ease-out ${
                    isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  }`}
                >
                  {/* The inner wrapper enables smooth height animation */}
                  <div className="overflow-hidden">
                    {/* Body text / comment */}
                    <p className="text-gray-300 mt-3">{item.description}</p>
                    {/* If you have longer copy, you can drop anything here */}
                    {item.body && (
                      <div className="prose prose-invert mt-3 text-gray-300">
                        {item.body}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
